<template>
  <div class="fatture-bottom">
    <hr />
    <h3 class="servizi-info-center">Stato fatturazione elettronica</h3>
    <div class="dettaglio-wrapper">
      <table class="table-fatture">
        <thead>
          <th colspan="2">Fatture attive</th>
          <th colspan="2"></th>
          <th colspan="2">Fatture passive</th>
          <th colspan="2"></th>
          <th colspan="2">Fatture acquistate</th>
        </thead>
        <tr>
          <td width="180px;">Numero</td>
          <td>{{ attiveNumero }}</td>
          <td width="50px;"></td>
          <td></td>
          <td width="180px;">Numero</td>
          <td align="right">{{ passiveNumero }}</td>
          <td width="50px;"></td>
          <td></td>
          <td width="180px;">Numero</td>
          <td align="right">---</td>
        </tr>
        <tr>
          <td>Scadenze non saldate</td>
          <td align="right">{{ attiveScadenze }}</td>
          <td></td>
          <td></td>
          <td>Scadenze non saldate</td>
          <td align="right">{{ passiveScadenze }}</td>
        </tr>
        <tr>
          <td :class="{'testo-rosso' : attiveNonTrasferite }">Non trasferite</td>
          <td align="right" :class="{'testo-rosso' : attiveNonTrasferite }">{{ attiveNonTrasferite }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import configurazioni from '@/services/configurazioniService.js'
import documenti from '@/services/documentiService.js'
import elettronica from '@/services/elettronicaService.js'

export default {
  data() {
    return {
      riepilogo: null,
      impostazioniDocumenti: null,
      timerAggiorna: null,
      fatturazioneElettronica: null
    }
  },
  async mounted() {
    const start = moment().startOf('year').format('YYYYMMDDHHmmss')
    const end = moment().endOf('year').format('YYYYMMDDHHmmss')
    const filtro = {
      start: start,
      end: end
    }
    const payload = {
      tipo: 'year'
    }
    this.impostazioniDocumenti = await configurazioni.getConfigurazione('documenti_impostazioni')
    await this.aggiornaStatiFatturazioneAttive()
    await this.aggiornaStatiFatturazionePassive()
    this.riepilogo = await documenti.statisticaRiepilogoFatture(filtro, payload)
  },
  computed: {
    passiveNumero() {
      return this.riepilogo ? this.riepilogo.passive.numero : '---'
    },
    passiveScadenze() {
      return this.riepilogo ? this.riepilogo.passive.scadenze : '---'
    },
    attiveNumero() {
      return this.riepilogo ? this.riepilogo.attive.numero : '---'
    },
    attiveScadenze() {
      return this.riepilogo ? this.riepilogo.attive.scadenze : '---'
    },
    attiveErrori() {
      return this.riepilogo ? this.riepilogo.attive.errori : '---'
    },
    attiveNonTrasferite() {
      return this.riepilogo ? this.riepilogo.attive.nonTrasferito : '---'
    }
  },
  methods: {
    async aggiornaStatiFatturazioneAttive() {
      const impostazioni = this.impostazioniDocumenti
      const giorniStoricoVerifica = impostazioni.trasmittente.giorniStoricoVerifica || 5
      const username = impostazioni.trasmittente.username
      const startDate = moment().add(-giorniStoricoVerifica, 'days').toISOString()
      const endDate = moment().toISOString()
      const cedente = impostazioni.impostazioni.cedenti[0]
      const countrySender = cedente.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese
      const vatcodeSender = cedente.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice
      await elettronica.out_findByUsername(username, startDate, endDate, countrySender, vatcodeSender)
    },
    async aggiornaStatiFatturazionePassive() {
      const fatturazioneElettronica = await configurazioni.getConfigurazione('fatturazione_elettronica')
      const dataUV = _.get(fatturazioneElettronica, 'fatturePassive.ricezione.dataUltimaVerifica')

      if (!dataUV || moment().diff(moment(dataUV), 'days') > 0) {
        // TODO: Verificare. Aggiorno la data una volta al giorno anche se entro più volte nel menù per evitare troppi aggiornamenti al db
        _.set(fatturazioneElettronica, 'fatturePassive.ricezione.dataUltimaVerifica', new Date())
        await configurazioni.modificaConfigurazione(fatturazioneElettronica)
      }
      this.fatturazioneElettronica = fatturazioneElettronica
      if (this.timerAggiorna) return
      if (_.get(this.fatturazioneElettronica, 'ricezione.abilitaVerifica', false)) return
      const impostazioni = this.impostazioniDocumenti
      const dataUltimaVerifica = (this.fatturazioneElettronica.ricezione && this.fatturazioneElettronica.ricezione.dataUltimaVerifica) || moment().add(-1, 'years').toDate() // se non ho mai scaricato, prendo un periodo lungo
      const username = impostazioni.trasmittente.username
      const startDate = moment(dataUltimaVerifica).toISOString()
      const endDate = moment().toISOString()
      const cedente = impostazioni.impostazioni.cedenti[0]
      const countrySender = cedente.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese
      const vatcodeSender = cedente.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice
      let result = await elettronica.in_findByUsername(username, startDate, endDate, countrySender, vatcodeSender)
      if (result.numeroRichieste && result.numeroRichieste > 12) {
        this.timerAggiorna = setInterval(async () => {
          console.log('avvio aggiornamento...')
          result = await elettronica.in_findByUsername(username, startDate, endDate, countrySender, vatcodeSender)
          console.log('pausa aggiornamento...')
          if (result.numeroRichieste && result.numeroRichieste < 12) {
            clearInterval(this.timerAggiorna)
            this.timerAggiorna = null
            console.log('fine aggiornamento')
          }
        }, 60000)
      }
    }
  }
}
</script>

<style lang="scss">
  .fatture-bottom {
    bottom: 0;
    position: absolute;
    width: 100%;
    min-height: 180px;
  }

  .servizi-info-center {
    text-align: center;
    width: 100%;
  }

  .dettaglio-header {
    font-weight: bold;
    font-size: 14px;
    padding-top: 15px;
    padding-bottom: 5px;
  }
  .dettaglio-righe {
    font-size: 12px;
  }
  .dettaglio-wrapper {
    margin-top: 5px;
    margin-left: 5px;
  }
  .dettaglio-cc {
    text-align: center;
  }
  .table-fatture {
    padding-bottom: 10px;
    margin-left: 10px;
  }
</style>
